<template>
  <div class="btn-group">
    <el-tooltip content="Revert" placement="top">
      <button v-if="canRevert && isRevertable" class="btn btn-warning btn-sm" @click="confirmReverting">
        <i class="fas fa-reply"></i>
      </button>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: {
      row: Object,
    },

    computed: {
      /**
       * @return {boolean}
       */
      canRevert() {
        return this.row.canRevert;
      },

      /**
       * @return {boolean}
       */
      isRevertable() {
        return _.get(this.row, 'model.is_revertable', false);
      },

      /**
       * @return {string}
       */
      revertUrl() {
        return this.row.revertUrl;
      },
    },

    methods: {
      /**
       * @event revert
       */
      confirmReverting() {
        this.$confirm('Are you sure you want to revert the import?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
            .then(() => this.$emit('revert', {row: this.row, url: this.revertUrl}))
            .catch(_.noop);
      },
    },
  }
</script>
